import React, { FC, Fragment } from "react";
import { useTranslation } from "Shared/util/custom-hooks";
import { formatDate } from "Shared/util/formatters";
import { SettingsCard } from "Shared/components/cards";
import { ComplianceSummarySignatories } from "Shared/util/types";
import styles from "./contract-settings-card.css";

type ContractSettingsCardProps = {
    className?: string;
    completed: boolean;
    signatories: ComplianceSummarySignatories[];
};

const getSignerTypeText = (signerType: string, t: any) => {
    switch (signerType) {
        case "Signatory":
            return t.signatory;
        case "Guarantor":
            return t.guarantor;
        case "SignatoryAndGuarantor":
            return t.signatory_and_guarantor;
        default:
            return `[${signerType}]`;
    }
};

export const ContractSettingsCard: FC<ContractSettingsCardProps> = ({
    signatories,
    completed,
    className,
}) => {
    const t = useTranslation((x) => x.company_settings.contract_settings_card);

    return (
        <SettingsCard
            status={{
                type: completed ? "VALID" : "INVALID",
                text: completed ? t.signed : t.to_complete,
            }}
            header={{
                text: t.contract,
            }}
            content={
                <div className={styles.container}>
                    {signatories.map((signatory) => (
                        <Fragment
                            key={`${signatory.name};${signatory.socialSecurityNumber}`}
                        >
                            <span className={styles.row}>{signatory.name}</span>
                            <span>{signatory.socialSecurityNumber}</span>
                            <span>
                                {getSignerTypeText(signatory.signerType, t)}
                            </span>
                            <span>
                                {signatory.signDate
                                    ? `${t.signed} ${formatDate(
                                          signatory.signDate,
                                      )}`
                                    : t.awaiting_signing}
                            </span>
                        </Fragment>
                    ))}
                </div>
            }
            className={className || ""}
        />
    );
};
